export default __webpack_public_path__ + "static/media/login_island.87924e1d.png";